import { render, staticRenderFns } from "./DisplayDiscount.vue?vue&type=template&id=33e4040f&scoped=true"
import script from "./DisplayDiscount.vue?vue&type=script&lang=js"
export * from "./DisplayDiscount.vue?vue&type=script&lang=js"
import style0 from "./DisplayDiscount.vue?vue&type=style&index=0&id=33e4040f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e4040f",
  null
  
)

export default component.exports